import { Component, OnInit } from '@angular/core';
import {Observable, of} from 'rxjs';
import {HttpClient} from '@angular/common/http';
import {catchError, take, tap} from 'rxjs/operators';
import {PortfolioItemModel} from '../../assets/data/portfolio-item.model';
import * as PIXI from 'pixi.js';
import { BulgePinchFilter, GlitchFilter, GlowFilter, CRTFilter } from 'pixi-filters';
import {BreakpointObserver, BreakpointState} from '@angular/cdk/layout';

@Component({
  selector: 'app-dev',
  templateUrl: './dev.component.html',
  styleUrls: ['./dev.component.scss']
})
export class DevComponent implements OnInit {
  hoveredAva: boolean;
  isMobile: boolean = undefined;

  years = [
    '2014', '2015', '2016', '2017', '2018', '2019', '2020 2021'
  ];

  public portfolioItems: PortfolioItemModel[];

  constructor(private http: HttpClient, private breakpointObserver: BreakpointObserver) {

  }

  ngOnInit(): void {
    this.breakpointObserver
      .observe(['(max-width: 768px)'])
      .subscribe((state: BreakpointState) => {
        if (state.matches) {
          this.isMobile = true;
        } else {
          this.isMobile = false;
          this.updateImage();
        }
      });
    this.getLocalJSONData()
      .subscribe(
        data => {
          this.portfolioItems = data.items;
        },
        error => console.error(`Failed to get data: ${error}`),
        () => {}
      );
  }

  getLocalJSONData(): Observable<any> {
    return this.http.get('../../assets/data/portfolio-items.json')
      .pipe(
        take(1),
        tap(data => console.log('data: ', data)),
        // catchError((err, caught) => caught)
      );
  }

  updateImage(): void {

    console.log('main.js start');

    const width = window.innerWidth;
    const height = window.innerHeight;
    const playground = document.createElement('div');
    playground.setAttribute('id', 'px-render');


    let canvas;

    const ratio = 1 / 1;

    let count = 0;
    let raf;


    // @ts-ignore
    const renderer = PIXI.autoDetectRenderer(width, height, {transparent: true});
    // @ts-ignore
    renderer.autoResize = true;
    // tslint:disable-next-line:one-variable-per-declaration
    let tp, tp2, preview, preview2,
      displacementSprite,
      displacementSprite2,
      displacementFilter,
      displacementFilter2,
      glowFilter,
      glitchFilter,
      bulgePinchFilter,
      crtfilter,
      crtfilter2,
      focus,
      // tslint:disable-next-line:prefer-const
      focusW = 0,
      stage;

    // tslint:disable-next-line:typedef
    function setScene(url) {
      document.getElementById('rend').appendChild(playground);
      playground.appendChild(renderer.view);

      stage = new PIXI.Container();


      tp = PIXI.Texture.from(url);
      preview = new PIXI.Sprite(tp);
      preview.alpha = 0;
      crtfilter = new CRTFilter({
        curvature: 1, lineWidth: 0.1, lineContrast: 0, noise: 0.2, noiseSize: 1, vignetting: 0, vignettingAlpha: 0,
        seed: 5, time: 1, blendMode: 1
      });
      crtfilter2 = new CRTFilter({
        curvature: 1, lineWidth: 1, lineContrast: 0, noise: 0.2, noiseSize: 1, vignetting: 0, vignettingAlpha: 1,
        seed: 10, time: 1, blendMode: 1
      });
      glowFilter = new GlowFilter({innerStrength: 0, outerStrength: 10});
      glitchFilter = new GlitchFilter({seed: 0.6});
      bulgePinchFilter = new BulgePinchFilter();

      // bulgePinchFilter.blendMode = PIXI.BLEND_MODES.MULTIPLY;
      // glitchFilter.blendMode = PIXI.BLEND_MODES.SCREEN;
      glowFilter.blendMode = PIXI.BLEND_MODES.OVERLAY;
      glitchFilter.blendMode = PIXI.BLEND_MODES.OVERLAY;
      bulgePinchFilter.blendMode = PIXI.BLEND_MODES.OVERLAY;

      tp2 = PIXI.Texture.from(url);
      preview2 = new PIXI.Sprite(tp2);
      preview2.alpha = 1;

      preview.anchor.x = 1;

      displacementSprite = PIXI.Sprite.from(document.querySelector('.displace')['src']);
      displacementSprite.texture.baseTexture.wrapMode = PIXI.WRAP_MODES.MIRRORED_REPEAT;
      displacementSprite2 = PIXI.Sprite.from(document.querySelector('.displace2')['src']);
      displacementSprite2.texture.baseTexture.wrapMode = PIXI.WRAP_MODES.REPEAT;

      displacementFilter = new PIXI.filters.DisplacementFilter(displacementSprite, 2);
      displacementFilter2 = new PIXI.filters.DisplacementFilter(displacementSprite, 3);

      displacementSprite.scale.y = -10;
      displacementSprite.scale.x = -10;
      displacementSprite2.scale.y = -10;
      displacementSprite2.scale.x = -10;


      stage.addChild(displacementSprite);

      stage.addChild(preview2);

      PIXI.settings.ROUND_PIXELS = true;

      // stage.addChild(preview);

      // Inner radius of the circle
      const radius = 200;

// The blur amount
      const blurSize = 300;

      const circle = new PIXI.Graphics()
        .beginFill(0x00F0F0)
        .drawCircle(radius + blurSize, radius + blurSize, radius)
        .endFill();
      circle.filters = [glowFilter, new PIXI.filters.BlurFilter(4)];
      // circle.alpha = 1;

      const bounds = new PIXI.Rectangle(0, 0, (radius + blurSize) * 2, (radius + blurSize) * 2);
      const texture = renderer.generateTexture(displacementSprite2, PIXI.SCALE_MODES.NEAREST, 1, bounds);
      // texture.blendMode = PIXI.BLEND_MODES.OVERLAY;

      focus = new PIXI.Sprite(texture);
      focus.blendMode = PIXI.BLEND_MODES.OVERLAY;
      stage.interactive = true;
      stage.blendMode = PIXI.BLEND_MODES.OVERLAY;
      displacementSprite.blendMode = PIXI.BLEND_MODES.OVERLAY;
      stage.addChild(focus);

      // stage.mask = focus;
      // displacementFilter.mask = focus;
      // displacementFilter2.mask = focus;
      // glowFilter.mask = focus;
      // glitchFilter.mask = focus;
      // bulgePinchFilter.mask = focus;
      // crtfilter.mask = focus;
      // crtfilter2.mask = focus;

      stage.on('mousemove', pointerMove);
      // stage.on('mouseout', pointerMove);

      // tslint:disable-next-line:typedef
      function pointerMove(event) {
        displacementSprite.position.x = event.data.global.x - focus.width / 2;
        displacementSprite.position.y = event.data.global.y - focus.height / 2;
      }

      // function pointerMove(event) {
      //   displacementSprite.position.x = 0;
      //   displacementSprite.position.y = 0;
      // }


      animate();
    }

    function removeScene(): void {
      cancelAnimationFrame(raf);
      stage.removeChildren();
      stage.destroy(true);
      playground.removeChild(canvas);
    }


    function animate(): void {
      raf = requestAnimationFrame(animate);

      let even = Math.random() * 2;
      if (even % 2 === 0) {
        even *= -1;
      }
      count += 0.1;
      // displacementSprite.x = count * 10 - 10;
      // displacementSprite.y = count * 10 - 10;
      displacementSprite2.x = count;
      displacementSprite2.y = count;
      // displacementSprite.x = Math.random() * 5 * count;
      // displacementSprite.y = Math.random() * 5 * count;
      //
      // displacementSprite.scale.y = Math.random() * 500;
      // displacementSprite.scale.x = Math.random() * 500;



      crtfilter.noise = Math.random() * 1 / 10;
      crtfilter2.noise = Math.random() * 1 / 10;
      // crtfilter.lineWidth = Math.random() * 10 / 10;
      // crtfilter2.lineWidth = Math.random() * 10 / 10;
      // crtfilter.curvature = Math.random() * 10 / 10;
      // crtfilter2.curvature = Math.random() * 10 / 10;
      //
      glitchFilter.seed = 1;
      glitchFilter.slices = Math.random() * 4;
      glitchFilter.offset = Math.sin(Math.random() * 4);
      // glitchFilter.direction = Math.random() * 360;
      // glitchFilter.red.y = Math.random() * 3 * even;
      // glitchFilter.red.x = Math.random() * 20 - 20;
      // glitchFilter.blue.y = Math.random() * 3 * even;
      // glitchFilter.blue.x =  Math.random() * 20 - 20;
      // glitchFilter.green.y = Math.random() * 3 * even;
      // glitchFilter.green.x = Math.random() * 20 - 20;
      // glitchFilter.fillMode = "mirror";
      //

      glitchFilter.red.y = displacementSprite.position.y;
      glitchFilter.red.x = displacementSprite.position.x;
      glitchFilter.blue.y = displacementSprite.position.y;
      glitchFilter.blue.x =  displacementSprite.position.x;
      glitchFilter.green.y = displacementSprite.position.y;
      glitchFilter.green.x = displacementSprite.position.x;

      bulgePinchFilter.radius = Math.random() * 5;
      bulgePinchFilter.strength = (1 / (Math.random() * 5));
      bulgePinchFilter.center.x = 1 / (Math.random() * 5);
      bulgePinchFilter.center.y = 1 / (Math.random() * 5);

      // preview2.x = Math.random() * 10 * even;
      // preview2.y = Math.random() * 10 * even;


      // let counting;
      // if (focusW == 0 || focusW < 300) {
      //   counting = true;
      //
      // if ( focusW == 300 || focusW > 300)
      //
      //   counting = false;
      // }
      // if (counting) {
      //   focusW += 2;
      // } else {
      //   focusW -= 2;
      // }


      // focus.width = focusW;
      // focus.height = focusW;


      // stage.filters = [displacementFilter, crtfilter, crtfilter2];
      // stage.filters = [displacementFilter, displacementFilter2, glitchFilter, crtfilter, crtfilter2, bulgePinchFilter];
      stage.filters = [bulgePinchFilter, crtfilter, glowFilter, displacementFilter2, glitchFilter];
      // stage.mask = focus;

      renderer.render(stage);
      canvas = playground.querySelector('canvas');

      // canvas.mask = focus;
    }

    setScene(document.querySelector('#img-s')['src']);
    console.log('main.js end');



  }

}
